module.exports = __webpack_public_path__ + "img/pt_Ecran 2.cbb1ff4a.png";